import { apiInchat } from 'api'
import types from './types'
import { addUserTab, setActiveChannel, setActiveUser } from 'redux/actions/tabs'
import _cloneDeep from 'lodash.clonedeep'
import { addBrackets } from 'components/InChatView/utils'

const addConversations = (conversation) => ({ type: types.INCHAT_ADD_CONVERSATIONS, conversations: { ...conversation } })

const updateConversation = (conversationId, data) => (dispatch, getState) => {
  const { inchat } = getState()
  const prevData = { ...inchat.conversations[conversationId].user }
  dispatch({
    type: types.INCHAT_UPDATE_CONVERSATION,
    payload: data
  })
  apiInchat.updateConversation(conversationId, data)
    .catch(() => {
      dispatch({
        type: types.INCHAT_UPDATE_CONVERSATION,
        payload: prevData
      })
    })
}

function getDirectConversationsList(nextPage = false, type='direct', limit=30) {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      let dataInchat = state.inchat[type]
      if(!dataInchat) {
        dataInchat = state.inchat.sections.conversations.find(conversation => conversation._id === type)
      }
      const prevConversations = [...dataInchat.conversations]
      if (prevConversations.length &&
        nextPage &&
        prevConversations.length < (limit * dataInchat.page)) return
      const newPage = nextPage ? dataInchat.page + 1 : 1
      const { data: { data } } = await apiInchat.getSectionInfo(dataInchat._id, {
        page: newPage,
        limit
      })
      let currentConversations = [...data.conversations]
      if(newPage > 1){
        currentConversations = [...prevConversations, ...currentConversations ]
      }
      dispatch({ type: types.INCHAT_GET_DIRECT_CONVERSATIONS_LIST, conversations: currentConversations, page: newPage, typeData: type, data: data } )
    } catch (err) {
      return 'error'
    }
  }
}

const getMainMenu = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const { inchat } = state
      const { data: { data } } = await apiInchat.getMainMenuInchat()
      const sectionsData = data.sections
      let direct = { ...inchat.direct }
      let channel = { ...inchat.channel }
      let sections = {
        conversations:[],
        sectionsOrder: [...data.sectionsOrder]
      }
      sectionsData.forEach(section => {
        switch (section.name) {
          case 'channel':
            channel = { ...channel, ...section, page: 1 }
            break
          case 'message_direct':
            direct = { ...direct, ...section, page: 1 }
            break
          default:
            sections.conversations.push(section)
            break
        }
      })
      delete data.sectionsOrder
      dispatch({
        type: types.INCHAT_GET_INFO_MAIN_MENU,
        payload: { inchat:{ ...inchat, ...data, direct, channel, sections, } }
      })
      dispatch(getScheduledMessages({ page: 0 }))
      dispatch(getTotalReactions())
    } catch (error) {
      throw new Error(error)
    }
  }
}

const getConversation = (conversationId) => async (dispatch, getState) => {
  try {
    const state = getState()
    const { inchat } = state
    let conversation = {}
    conversation = searchConversation(inchat.direct.conversations, conversationId)
    if(!conversation) conversation = searchConversation(inchat.channel.conversations, conversationId)
    if(conversation && conversation._id === conversationId){
      dispatch(addConversations(conversation))
      dispatch(selectConversation(conversationId))
      return
    }else {
      const { data: { data } } = await apiInchat.getConversationInfo({ conversationId })
      conversation = Object.assign({ ...data }, {
        channel: 'inchat',
        provider: 'inchat',
        _id: data.conversationId,
        totalUnreadMessages: 0,
        lastUnreadMessages: [],
        users: data.users.map(user => user._id),
        usersInfo: data.users.map(user => ({ ...user, id: user._id })),
      })
      dispatch(addConversations(conversation))
      dispatch(selectConversation(conversationId))
      return
    }
  } catch (error) {
    console.error(error)
    throw error
  }
}

const searchConversation = (data, conversationId) => data.find((conversation) => conversation._id === conversationId)

const selectConversation = (conversationId) => {
  return (dispatch) => {
    dispatch(setActiveChannel('inchat'))
    dispatch(setActiveUser(conversationId))
    dispatch(addUserTab(conversationId, 'inchat'))
  }
}

/**
 * @param {String} message
 */
const editMessage = params => (dispatch, getState) => {
  const { message, isThread, draftId, messageId, external, conversationId: _conversationId, parentId } = params
  const conversationId = _conversationId || getState().tabs.activeUser

  dispatch({
    conversationId,
    type: types.INCHAT_COMPOSER_EDIT_MESSAGE,
    message: message,
    isThread,
    draftId,
    messageId: messageId,
    parentId,
    external
  })
}

const updateMessageExternal = (external) => {
  return (dispatch, getState) => {
    const conversationId = getState().tabs.activeUser
    dispatch({
      type: types.INCHAT_MESSAGE_UPDATE_EXTERNAL,
      payload: { external, conversationId }
    })
  }
}

const uploadingFile = (conversationId, value, isThread) => (dispatch) => {
  dispatch({
    conversationId,
    type: types.INCHAT_COMPOSER_UPLOADING_FILE,
    value,
    isThread,
  })
}

/**
 * Upload files to s3
 * @param {Array} files
 */
const uploadFiles = (files, conversationId, isThread, newConversationId) => async (dispatch, getState) => {
  if (!files.length) return null

  dispatch(uploadingFile(newConversationId, true, isThread))

  const formData = new FormData()
  formData.append('conversationId', conversationId)
  files.forEach(it => {
    formData.append('files', it.file)
  })

  return apiInchat
    .uploadFiles(formData)
    .then(({ data, status }) => {
      dispatch(editMessageAddAttachments(newConversationId, data.files, isThread))
      return data.attachments
    })
    .catch(({ response = {}, message }) => {
      dispatch(uploadingFile(newConversationId, false, isThread))
      const { data = {}, status } = response
      const error = data.type ? data.type : status === 413 ? 'file-too-big' : 'upload-file-error'
      throw error
    })
}

const updateMentions = (conversationId, mentions, isThread) => (dispatch) => {
  dispatch({
    type: types.INCHAT_COMPOSER_EDIT_MENTIONS,
    payload: { conversationId, mentions, isThread }
  })
}

const editMessageAddAttachments = (conversationId, attachments, isThread, requireClean) => (dispatch, getState) => {
  dispatch({
    conversationId,
    type: types.INCHAT_COMPOSER_ADD_ATTACHMENTS,
    attachments,
    isThread,
    requireClean,
  })
}

/**
 * @param {String} message
 * @param {String} attachmentId
 * @param {Boolean} isThread
 */
const editMessageRemoveAttachment = (conversationId, attachmentId, isThread) => (dispatch, getState) => {
  dispatch({
    conversationId,
    type: types.INCHAT_COMPOSER_REMOVE_ATTACHMENT,
    attachmentId,
    isThread,
  })
}

const sendMessage = (conversationId, isThread, _composer, newConversationId) => async (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const { inchat } = getState()
    const scheduled = inchat.scheduled
    const composer = _composer ? _composer : inchat.conversations[newConversationId].composer

    const message = {
      type: 'direct',
      conversationId: conversationId,
      message: addBrackets(composer.message),
      attachments: composer.attachments?.length > 0 ? composer.attachments : undefined,
      parentId: isThread ? composer.parentId : undefined,
    }

    if (composer?.messageId) {
      const messageEdit = {
        type: message.type,
        conversationId: conversationId,
        newText: message.message,
        attachments: message.attachments,
      }
      apiInchat.updateMessage(composer.messageId, messageEdit)
        .then(() => {
          dispatch(cleanComposer(newConversationId, isThread))
          return resolve(true)
        })
    }
    else {
      apiInchat.sendMessage(message)
        .then(async() => {
          if (scheduled.messageToEdit?.conversationId === conversationId) {
            dispatch(deleteScheduleMessage({ data: { id: scheduled.messageToEdit.id, conversationId } }))
          }
          if (composer.draftId) {
            try {
              await apiInchat.draftRemove({ conversationId, draftId: composer.draftId })
            } catch (error) {
              console.error(error)
            }
          }
          !_composer && dispatch(cleanComposer(newConversationId, isThread))
          return resolve(true)
        })
        .catch((error) => {
          console.error(error)
          return reject(error)
        })
    }
  })
}

const updateChatState = data => (dispatch, getState) => {
  const { tabs: { activeUser } } = getState()

  dispatch({
    type: types.INCHAT_UPDATE_CHAT_STATE,
    payload: { conversationId: activeUser, ...data }
  })
}

const getConversationMessages = data => (dispatch, getState) => {
  const { tabs: { activeUser: conversationId } } = getState()
  const page = data.page || 1
  dispatch(updateChatState({ isLoadingMessages: true }))
  apiInchat.getConversationMessages({ ...data, limit: 30, page })
    .then(({ data: { data } }) => {
      dispatch({
        type: types.INCHAT_SET_CONVERSATION_MESSAGES,
        payload: { conversationId, messages: data || [], page },
      })
    })
    .catch(error => console.error(error))
    .finally(() => dispatch(updateChatState({ isLoadingMessages: false })))
}

const getScheduledMessages = (params = {}) => (dispatch, getState) => {
  const { page } = params
  const { inchat } = getState()
  const { page: currentPage, limit } = inchat.scheduled

  dispatch({
    type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
    payload: { loading: true }
  })
  apiInchat.getScheduledMessages({ page: page || currentPage, limit })
    .then(result => {
      const { messages } = result.data
      dispatch({
        type: types.INCHAT_SET_SCHEDULED_MESSAGES,
        payload: { messages }
      })
      if (messages.length < limit) {
        dispatch({
          type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
          payload: { isAll: true }
        })
      }
    })
    .catch(console.error)
    .finally(() => {
      dispatch({
        type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
        payload: { loading: false }
      })
    })
}

const getMoreMessages = () => (dispatch, getState) => {
  const { inchat } = getState()
  const { page } = inchat.scheduled
  const newPage = page + 1

  getScheduledMessages({ page: newPage })

  dispatch({
    type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
    payload: { page: newPage }
  })
}

const setScheduledMessageToEdit = data => ({
  type: types.INCHAT_SET_SCHEDULED_MESSAGE_TO_EDIT,
  payload: data
})

const deleteScheduleMessage = (params = {}) => (dispatch, getState) => {
  const { data: { id, conversationId }, onFinish } = params
  const { inchat } = getState()
  const scheduledMessages = [...inchat.scheduled.data]

  dispatch({
    type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
    payload: { deleting: true }
  })
  const scheduledMessageIndex = scheduledMessages.findIndex(message => message._id === id)
  scheduledMessages.splice(scheduledMessageIndex, 1)

  apiInchat.deleteScheduledMessage({ id, conversationId })
    .then(() => {
      dispatch({
        type: types.INCHAT_SET_SCHEDULED_MESSAGES,
        payload: { messages: scheduledMessages }
      })
    })
    .finally(() => {
      dispatch({
        type: types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES,
        payload: { deleting: false }
      })
      if (typeof onFinish === 'function') onFinish()
    })
}

const getMessagesThreadsByMessage = (conversationId, _from, newConversationId) => async (dispatch, getState) => {
  const { inchat } = getState()
  const from = _from || 1
  const composer = inchat.conversations[newConversationId].composer

  dispatch(updateThreadState(conversationId, true))

  apiInchat.getThreadsByMessage({
    conversationId,
    messageId: composer?.parentId,
    size: 30,
    from,
  }).then(({ data: { data } }) => {
    dispatch({
      type: types.INCHAT_SET_THREADS_MESSAGES,
      conversationId,
      messages: data,
      from,
    })
  }).catch(error => { throw error })
    .finally(() => dispatch(updateThreadState(conversationId, false)))
}

const updateThreadState = (conversationId, isLoadingMessages) => (dispatch) => {
  dispatch({
    type: types.INCHAT_UPDATE_THREAD_STATE,
    conversationId,
    isLoadingMessages,
  })
}

const setNewDirectMessage = message => ({
  type: types.INCHAT_SET_NEW_DIRECT_MESSAGE,
  payload: { message }
})

const setNewThreadMessage = (message) => ({
  type: types.INCHAT_SET_NEW_THREAD_MESSAGE,
  message
})

const cleanComposer = (conversationId, isThread) => (dispatch, getState) => {
  const { inchat } = getState()
  const scheduled = inchat.scheduled

  dispatch({
    type: types.INCHAT_COMPOSER_CLEAN,
    conversationId,
    isThread,
  })

  if (scheduled.messageToEdit?.id) dispatch(setScheduledMessageToEdit({}))
}

const removeConversationChannel = (conversationId) => {
  return (dispatch, getState) => {
    const { inchat } = getState()
    const { conversations } = inchat.channel
    const newConversations = conversations.filter(conversation => conversation._id !== conversationId)
    dispatch({
      type: types.INCHAT_UPDATE_CONVERSATIONS,
      payload: { newConversations }
    })}
}

const addConversationChannel = (conversationId) => {
  return (dispatch, getState) => {
    const state = getState()
    const { conversations } = state.inchat.channel
    const conversationFind = conversations.find(conversation => conversation._id === conversationId)
    if(!conversationFind){
      dispatch(getDirectConversationsList(false, 'channel'))
    }
  }
}

const updateChannelMute = (conversationId, isMute ) => {
  return (dispatch, getState) => {
    const { inchat } = getState()
    const { conversations } = inchat.channel
    const index = conversations.findIndex(conversation => conversation._id === conversationId)
    const newConversations = [...conversations]
    const conversationUpdated = { ...newConversations[index] }
    conversationUpdated.isMuted = isMute
    newConversations[index] = conversationUpdated
    dispatch({
      type: types.INCHAT_UPDATE_CONVERSATIONS,
      payload: { newConversations }
    })}
}

const removeConversation = (conversationId) => (dispatch, getState) => {
  const { tabs } = getState()
  if (!tabs?.users.find(user => user.id === conversationId)) {
    dispatch({
      conversationId,
      type: types.INCHAT_REMOVE_CONVERSATION,
    })
  }
}

const removeAllConversations = () => (dispatch) => {
  dispatch({
    type: types.INCHAT_REMOVE_ALL_CONVERSATIONS,
  })
}

const onToggleThreads = (conversationId, parentId) => (dispatch, getState) => {
  // SI SE CIERRA EL SIDEMODAL SE LIMPIA EL COMPOSER DE LOS HILOS
  // if (inchat.isOpenThreads) {
  //   // dispatch(cleanComposer(parentId ? `${conversationId}_${parentId}`  : conversationId, true))
  //   dispatch(removeConversation(conversationId))
  // }
  dispatch({
    conversationId,
    parentId,
    type: types.INCHAT_ON_TOGGLE_THREADS,
  })
}

const updateUsersConversation = (conversationId, users, type) => {
  return async (dispatch, getState) => {
    const { inchat, tabs } = getState()
    const { conversations } = inchat.channel
    const conversationIndex = conversations.findIndex(con => con._id === conversationId)
    const conversation = conversations.find(con => con._id === conversationId)
    if(conversation && conversationIndex > -1){
      let newUsers = []
      let newUsersInfo = []
      if(type === 'kick'){
        newUsersInfo = conversation.usersInfo.filter(user => !users.includes(user._id))
        newUsers = conversation.users.filter(user => !users.includes(user))
      }else if(type === 'invite'){
        newUsers = [...conversation.users]
        users.forEach(user => {
          const exist = newUsers.some(newUser => newUser === user._id)
          if(!exist){
            newUsers.unshift(user._id)
          }
        })
        newUsersInfo = [...conversation.usersInfo]
        users.forEach(user => {
          const exist = newUsersInfo.some(newUserInfo => newUserInfo._id === user._id)
          if(!exist){
            newUsersInfo.unshift({ ...user, id: user._id })
          }
        })
      }
      dispatch({
        type: types.INCHAT_UPDATE_USERS_CONVERSATION,
        payload: { users: newUsers, usersInfo: newUsersInfo, index: conversationIndex }
      })
      if(tabs.activeUser === conversationId){
        dispatch(updateConversationComposer(newUsersInfo, conversationId, newUsers))
      }
    }
  }
}

const updateConversationComposer = (usersInfo, conversationId, users) => {
  return dispatch => {
    dispatch({
      type: types.INCHAT_UPDATE_INFO_CONVERSATION_COMPOSER,
      payload: { usersInfo, conversationId, users }
    })
  }
}

const updateFilterDirect = (filter) => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const { direct } = state.inchat
      const { data: { data } } = await apiInchat.updateSectionInfo(direct._id, filter)
      if(data){
        dispatch({
          type: types.INCHAT_UPDATE_FILTERS_DIRECT,
          payload: { ...filter, conversations: data.section.conversations, page: 1 }
        })
        return data
      }
      throw new Error('error')
    } catch (error) {
      throw new Error(error)
    }
  }
}

const updateSections = (newSection) => ({
  type: types.INCHAT_UPDATE_SECTIONS,
  payload: newSection
})

const updateMessageReactions = data => ({
  type: types.INCHAT_UPDATE_MESSAGE_REACTIONS,
  payload: data
})

const removeSection = (sectionId) => ({
  type: types.INCHAT_REMOVE_SECTION,
  payload: { sectionId }
})

const updateSectionOrder = ({ indexOrigin, indexDestination }) => {
  return (dispatch, getState) => {
    const state = getState()
    const { sectionsOrder } = state.inchat.sections
    let newSectionsOrder = [...sectionsOrder]
    const originSection = newSectionsOrder[indexOrigin]
    newSectionsOrder.splice(indexOrigin, 1)
    newSectionsOrder.splice(indexDestination, 0, originSection)
    dispatch({
      type: types.INCHAT_UPDATE_ORDER_SECTIONS,
      payload: { sectionsOrder: newSectionsOrder }
    })
    apiInchat.orderSections({
      newConversationsOrder: newSectionsOrder
    }).then()
      .catch(() => {
        dispatch({
          type: types.INCHAT_UPDATE_ORDER_SECTIONS,
          payload: { sectionsOrder: [...sectionsOrder] }
        })
      })
  }
}

const moveConversationSectionDirect = (values) => {
  return (dispatch, getState) => {
    const state = getState()
    const { direct, sections } = state.inchat
    const {
      conversationId,
      sourceId,
      sourceIndex,
      destinationId,
    } = values
    const newSections = _cloneDeep(sections.conversations)
    const newDirect = _cloneDeep(direct)
    let groupId = destinationId
    if(sourceId === 'message_direct'){
      const { datainfo: section, dataIndex: sectionIndex } = conversationAndIndex(newSections, destinationId)
      const conversationChange = findConversation(newDirect.conversations, conversationId)
      changesInConversations(section.conversations, conversationChange, newDirect.conversations, sourceIndex)
      newSections[sectionIndex] = section
    } else if(destinationId === 'message_direct'){
      const { datainfo: section, dataIndex: sectionIndex } = conversationAndIndex(newSections, sourceId)
      const conversationChange = findConversation(section.conversations, conversationId)
      changesInConversations(newDirect.conversations, conversationChange, section.conversations, sourceIndex)
      groupId = newDirect._id
      newSections[sectionIndex] = section
    } else {
      const { datainfo: sectionSource, dataIndex: sectionIndexSource } = conversationAndIndex(newSections, sourceId)
      const { datainfo: sectionDestination, dataIndex: sectionIndexDestination } = conversationAndIndex(newSections, destinationId)
      const conversationChange = findConversation(sectionSource.conversations, conversationId)
      changesInConversations(sectionDestination.conversations, conversationChange, sectionSource.conversations, sourceIndex)
      newSections[sectionIndexSource] = sectionSource
      newSections[sectionIndexDestination] = sectionDestination
    }
    dispatch({
      type: types.INCHAT_MOVE_CONVERSATIONS_SECTIONS_DIRECT,
      payload: { direct: newDirect, sections: { ...sections, conversations: newSections } }
    })
    apiInchat.updateSectionInfo(groupId, {
      conversationIds: [conversationId],
      actionConversation: 'add'
    }).then(() => {
      dispatch(getMainMenu())
    }).catch(() => dispatch(getMainMenu()))
  }
}

const conversationAndIndex = (data, id) => {
  const datainfo = data.find(sec => sec._id === id)
  const dataIndex = data.findIndex(sec => sec._id === id)
  return { datainfo, dataIndex }
}
const findConversation = (data, id) => data.find(data => data._id === id)
const changesInConversations = (dataConversationAdd, conversationAdd, dataConversationDelete, indexDelete) => {
  dataConversationAdd.splice(0, 0, conversationAdd)
  dataConversationDelete.splice(indexDelete, 1)
}

const updateDeleteMessage = (conversationId, messageId) => {
  return (dispatch, getState) => {
    const state = getState()
    const { conversations, threads } = state.inchat
    let conversationsUpdated = threads ? threads[conversationId] : undefined
    let newMessages = []
    if(conversationsUpdated){
      newMessages = [...conversationsUpdated.messages]
    }else{
      conversationsUpdated = conversations ? conversations[conversationId] : undefined
      if(conversationsUpdated){
        newMessages = [...conversationsUpdated.chat.messages]
      }
    }
    const message = newMessages.find(message => message._id === messageId)
    const indexMessages = newMessages.findIndex(messa => messa._id === message._id)
    if(indexMessages !== -1){
      newMessages.splice(indexMessages, 1, { ...message, isRemoved: true, text: 'message_deleted', attachments: [] })
      if(message.isThread){
        dispatch({
          type: types.INCHAT_SET_THREADS_MESSAGES,
          conversationId,
          messages: newMessages || [],
          from: conversationsUpdated.from,
        })
        return
      }
      dispatch(updateChatState({ conversationId: message.conversationId, messages: newMessages || [] }))
    }
  }
}

const getPinnedMessages = (conversationId) => (dispatch) => {
  apiInchat.pinList({ conversationId, showAll: false })
    .then(({ data: { data } }) => {
      dispatch({
        type: types.INCHAT_SET_PINNED_MESSAGES,
        conversationId,
        messages: data?.messages || [],
      })
    }).catch((error) => {
      throw error
    })
}

const updateCountPinnedMessages = (conversationId, count) => (dispatch) => {
  dispatch({
    type: types.INCHAT_UPDATE_COUNT_PINNED_MESSAGES,
    conversationId,
    count,
  })
}

const updatePinnedMessage = (conversationId, messageId, isThread, isPin) => (dispatch, getState) => {
  const state = getState()
  const { conversations, threads } = state.inchat
  const conversationsToUpdate = !isThread ? { ...conversations[conversationId] } : { ...threads[conversationId] }
  const messages = isThread ? [...conversationsToUpdate.messages] : [...conversationsToUpdate.chat.messages]
  const message = messages.find(message => message._id === messageId)
  if (message) {
    const newMessage = {
      ...message,
      isPin,
    }
    dispatch(updateMessage(newMessage))
  }
}

const getDrafts = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiInchat.draftList()
      .then(({ data: { data } }) => {
        dispatch({
          type: types.INCHAT_SET_DRAFTS,
          drafts: data || [],
        })
        return resolve(data)
      }).catch((error) => {
        return reject(error)
      })
  })
}

const getDraftsByConversation = (conversationId, parentId, draftId) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const newConversationId = parentId ? `${conversationId}_${parentId}` : conversationId
    const draftIdForEdit = draftId || getState().inchat.draftIdForEdit

    apiInchat.draftConversation({ conversationId, draftId, parentId })
      .then(({ data: { data } }) => {

        let draft = null
        if (draftIdForEdit) {
          draft = data.find(draft => draft._id === draftIdForEdit)
          dispatch(setDraftId(null))
        }

        if (!draft) {
          if (parentId) {
            draft = data.find(draft => draft.parentId === parentId)
          }

          if (!draft) {
            draft = data.filter(draft => draft.parentId === undefined)[0] || null
          }

        }
        if (draft) {
          draft.content && dispatch(editMessage({
            conversationId: newConversationId,
            message: draft.content,
            isThread: draft.isThread || parentId ? true : false,
            draftId: draft._id,
            parentId: draft.parentId || undefined,
          }))
          draft.attachments?.length > 0 && dispatch(editMessageAddAttachments(
            newConversationId,
            draft.attachments,
            draft.isThread || parentId ? true : false,
            true,
          ))
        }
        return resolve(draft)
      }).catch((error) => {
        dispatch(setDraftId(null))
        return reject(error)
      })
  })
}

const setDraftId = (draftIdForEdit) => (dispatch) => {
  dispatch({
    type: types.INCHAT_SET_DRAFT_ID,
    draftIdForEdit,
  })
}

const updateMessage = (message) => {
  return (dispatch, getState) => {
    const state = getState()
    const { isThread, conversationId } = message
    const { conversations, threads } = state.inchat
    const conversationsUpdated = !isThread ? { ...conversations[conversationId] } : { ...threads[conversationId] }
    if(conversationsUpdated){
      const newMessages = isThread ? [...conversationsUpdated.messages] : [...conversationsUpdated.chat.messages]
      const indexMessages = newMessages.findIndex(messa => messa._id === message._id)
      if(indexMessages !== -1){
        newMessages.splice(indexMessages, 1, message)
        if(isThread){
          dispatch({
            type: types.INCHAT_SET_THREADS_MESSAGES,
            conversationId,
            messages: newMessages || [],
            from: conversationsUpdated.from,
          })
          return
        }
        dispatch(updateChatState({ conversationId: message.conversationId, messages: newMessages || [] }))
      }
    }
  }
}

const updateCountSavedMessages = (count) => (dispatch) => {
  dispatch({
    type: types.INCHAT_UPDATE_COUNT_SAVED_MESSAGES,
    count,
  })
}

const updateSavedMessage = (conversationId, messageId, isThread, isSave) => (dispatch, getState) => {
  const state = getState()
  const { conversations, threads } = state.inchat
  const conversationsToUpdate = !isThread ? { ...conversations[conversationId] } : { ...threads[conversationId] }
  const messages = isThread ? [...conversationsToUpdate.messages] : [...conversationsToUpdate.chat.messages]
  const message = messages.find(message => message._id === messageId)
  if (message) {
    const newMessage = {
      ...message,
      isSave,
    }
    dispatch(updateMessage(newMessage))
  }
}

const updateCountDraftMessages = (count) => (dispatch) => {
  dispatch({
    type: types.INCHAT_UPDATE_COUNT_DRAFT_MESSAGES,
    count,
  })
}

const getTotalReactions = () => {
  return async (dispatch, getState) => {
    const state = getState()
    try {
      const { data: { total } } = await apiInchat.showTotalReactions(state.user._id)
      dispatch(updateReactionsMentions(total || 0))
    } catch (error) {
      console.error({ error })
    }
  }
}

const updateReactionsMentions = (count, type = 'new') => ({
  type: types.INCHAT_UPDATE_COUNT_MENTIONS_REACTIONS,
  payload: { count }
})

const updateUnreadMessages = (conversationId, totalMessages, activeUser) => ({
  type: types.INCHAT_UPDATE_UNREAD_MESSAGES,
  payload: { conversationId, totalMessages, activeUser }
})

const seenMessages = (conversationId) => {
  return async (dispatch, getState) => {
    try {
      const { tabs } = getState()
      await apiInchat.seenMessages({
        conversationId
      })
      dispatch(updateUnreadMessages(conversationId, 0, tabs.activeUser))
    } catch (error) {
      console.error(error)
    }
  }
}

export default {
  addConversations,
  updateConversation,
  getDirectConversationsList,
  getMainMenu,
  getConversation,
  getConversationMessages,
  getScheduledMessages,
  getMoreMessages,
  setScheduledMessageToEdit,
  deleteScheduleMessage,
  sendMessage,
  editMessage,
  setNewDirectMessage,
  uploadFiles,
  cleanComposer,
  updateMentions,
  editMessageAddAttachments,
  removeConversationChannel,
  addConversationChannel,
  updateChannelMute,
  editMessageRemoveAttachment,
  removeConversation,
  removeAllConversations,
  onToggleThreads,
  getMessagesThreadsByMessage,
  setNewThreadMessage,
  updateUsersConversation,
  updateFilterDirect,
  updateSections,
  updateMessageReactions,
  removeSection,
  updateSectionOrder,
  moveConversationSectionDirect,
  updateDeleteMessage,
  getPinnedMessages,
  getDrafts,
  setDraftId,
  updateMessageExternal,
  updateMessage,
  updateCountPinnedMessages,
  updatePinnedMessage,
  updateCountSavedMessages,
  updateSavedMessage,
  updateCountDraftMessages,
  updateReactionsMentions,
  getTotalReactions,
  getDraftsByConversation,
  seenMessages,
  updateUnreadMessages
}
